import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Block.module.scss';
import clsx from 'clsx';
const Block = ({ title, children, className, classNameTitle, line }) => {
  return (
    <>
      <div className={clsx(styles.wrap, className)}>
        {title && <div className={clsx(styles.title, classNameTitle, line && styles.titleLine)}>{title}</div>}

        {children}
      </div>
    </>
  );
};

export default Block;
